import { MuiOtpInput } from 'mui-one-time-password-input';
import React from 'react';

import { InputRenderer } from '../types';

const OTPInput = ({ inputProps }: InputRenderer) => (
  <MuiOtpInput {...inputProps} length={6} sx={{ gap: { xs: '0.5rem', md: '1rem' } }} />
);

export default OTPInput;
